import React, { useState } from "react";
import Diagrama from "../Diagrama";
import { infoServicio } from "modAws/CatalogoAws";

const reducido = () => { try { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e) { return false; } };

// Ficha de una amenaza: que es, como funciona, que provoca y como se defiende; si tiene escena, se ve el ataque con y sin la defensa.
const CuadroAtaque = ({ ataque, onServicio }) => {
    const [conDefensa, setConDefensa] = useState(true);
    const [pausado, setPausado] = useState(reducido());
    const e = ataque.escena;
    return (
        <div>
            <div className="text-muted small">Amenaza · {ataque.categoria}</div>
            <h4 className="mb-2"><i className="fa fa-user-secret me-2 text-danger" />{ataque.titulo}</h4>
            <p style={{ fontSize: 16 }}>{ataque.que}</p>
            {e && (
                <div className="card mb-3">
                    <div className="card-header d-flex align-items-center flex-wrap gap-2">
                        <b className="me-auto"><i className="fa fa-film me-2" />Con y sin defensa</b>
                        <div className="form-check form-switch m-0 no-imprimir">
                            <input className="form-check-input" type="checkbox" role="switch" id="def-sw" checked={conDefensa} onChange={() => setConDefensa(v => !v)} />
                            <label className="form-check-label" htmlFor="def-sw">{e.defensa}</label>
                        </div>
                        <button className="btn btn-sm btn-outline-secondary no-imprimir" onClick={() => setPausado(p => !p)}><i className={`fa fa-${pausado ? "play" : "pause"} me-1`} />{pausado ? "Reproducir" : "Pausar"}</button>
                    </div>
                    <div className="card-body">
                        <Diagrama key={ataque.id} patron="libre" nodos={e.nodos} flujosLibres={[]} color="#8C4FFF" paso={0} pausado={pausado}
                            ataque={{ ruta: e.ruta, bloqueaEn: conDefensa ? e.bloqueaEn : null, origen: e.origen }} quitados={conDefensa ? null : new Set([e.bloqueaEn])} />
                        <div role="status" className={`alert ${conDefensa ? "alert-success" : "alert-danger"} py-2 small mt-2 mb-0`}>
                            {conDefensa ? `Con «${e.defensa}» el ataque se detiene antes de llegar a su objetivo.` : `Sin «${e.defensa}» el ataque llega hasta el final.`}
                        </div>
                    </div>
                </div>
            )}
            <div className="row g-3">
                <div className="col-md-6"><div className="fw-bold"><i className="fa fa-cogs me-1" />Cómo funciona</div><p className="mb-0">{ataque.como}</p></div>
                <div className="col-md-6"><div className="fw-bold text-danger"><i className="fa fa-exclamation-triangle me-1" />Qué puede provocar</div><p className="mb-0">{ataque.impacto}</p></div>
            </div>
            <div className="fw-bold text-success mt-3"><i className="fa fa-shield-alt me-1" />Cómo defenderse</div>
            <ul className="mb-2">{ataque.defensas.map((t, k) => <li key={k}>{t}</li>)}</ul>
            <div className="no-imprimir">{ataque.servicios.map(id => { const i = infoServicio(id); return i ? (
                <button key={id} className="btn btn-sm btn-outline-secondary me-1 mb-1" onClick={() => onServicio && onServicio(id)}><i className={`${i.servicio.icon} me-1`} />{i.servicio.title}</button>) : null; })}</div>
            <div className="small text-muted mt-3">Contenido educativo y defensivo: explica la amenaza para poder protegerse, no cómo ejecutarla.</div>
        </div>
    );
};

export default CuadroAtaque;
